import strNormalize from "./strNormalize";

export default function strSlug(str: string, separator: string = '-') {
    return strNormalize(str)
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, separator)
        .replace(/^-+|-+$/g, '');
}